import { useTranslation } from 'next-i18next/pages';

import { EmployerDifferentiation as Differentiation } from '@pflegia/types/api/employer';
import { ReactComponent as DifferentiationIcon } from '@pflegia/ui/icons/differentiation-icon.svg';

import Section, { SectionTitle } from '../section/Section.component';

export interface EmployerDifferentiationProps {
  differentiations: Differentiation[];
}

export const EmployerDifferentiation = ({ differentiations }: EmployerDifferentiationProps) => {
  const { t } = useTranslation('jobDetails', { keyPrefix: 'differentiations' });

  return (
    <Section>
      <SectionTitle t={t} titleKey='title' />

      <ul className='mt-6 flex flex-row flex-wrap justify-center gap-16 md:gap-x-32'>
        {differentiations.map(item => (
          <li key={item.id} className='text-default flex max-w-70 flex-col items-center text-center'>
            <DifferentiationIcon />
            <h5 className='my-2 text-xl font-medium'>{item.title}</h5>
            {item.subtitle && <p className='font-light'>{item.subtitle}</p>}
          </li>
        ))}
      </ul>
    </Section>
  );
};

export default EmployerDifferentiation;
